import { useQuery } from '@tanstack/react-query';

import { validateCommentLink } from '@/api/v4/comments.api';
import { QueryKey } from '@/config/query-client';

export const useValidateCommentLink = (linkId: string) => {
  return useQuery({
    queryKey: [QueryKey.CommentLink, 'validate', linkId],
    queryFn: () => validateCommentLink({ linkId }),
    enabled: !!linkId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
};
